<template>
    <el-dialog
        title="签约文件"
        :visible="visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="handleClose"
        width="884px"
        v-on:close="handleClose"
    >
        <script-import :src="`${publicPath}js/pdf/pdf.js`"></script-import>
        <script-import :src="`${publicPath}js/pdf/pdf.worker.js`"></script-import>
        <div class="dialog-content">
            <div class="left-title">
                <div
                    v-for="(item, ind) in contractArray"
                    :key="ind"
                    class="contract-item"
                    :class="{ active: item.currentFlag }"
                >
                    <img :src="item.imgShow" class="img-size" />
                    <span>{{ item.title }}</span>
                </div>
            </div>
            <div class="right-content">
                <div v-show="!showRiskConfirm" style="width: 100%">
                    <div
                        id="pdf-container-parent"
                        ref="pdfContainer"
                        class="content-body"
                        v-on:scroll="handleScroll"
                    >
                        <div v-if="pdfContainerShow" id="pdf-container" ref="pdfContent"></div>
                    </div>
                    <div class="content-bottom">阅读完毕即可签署</div>
                </div>
                <div v-show="showRiskConfirm" class="risk-confirm">
                    <div v-if="riskConfirmTitle.length > 0" style="margin-bottom: 5px">
                        {{ riskConfirmTitle }}
                    </div>
                    <div v-for="(item, indx) in riskConfirmOption" :key="indx" class="agree-box">
                        <el-checkbox v-model="item.checkFlag" size="mini"></el-checkbox>
                        <span class="agree-text">
                            {{ indx + 1 + "、" + item.text }}
                        </span>
                    </div>
                </div>

                <div class="dialog-footer">
                    <el-button
                        v-if="filetype == '2' && !showRiskConfirm"
                        type="primary"
                        class="btn"
                        :disabled="!isScrolledToBottom"
                        :class="{ 'btn-disabled': !isScrolledToBottom }"
                        v-on:click="
                            () => {
                                showRiskConfirm = true;
                            }
                        "
                    >
                        进入风险揭示书确认
                    </el-button>
                    <el-button
                        v-if="filetype == '2' && showRiskConfirm"
                        type="primary"
                        class="btn"
                        :disabled="checkAllFlag"
                        v-on:click="gotoRiskConfirm(index + 1)"
                    >
                        确认
                    </el-button>
                    <el-button
                        v-if="filetype != '2' && index < contractArray.length - 1"
                        type="null"
                        class="btn btn-null"
                        :disabled="index == 0"
                        :class="{ 'btn-disabled': index == 0 }"
                        v-on:click="chooseItem(index - 1)"
                    >
                        上一份
                    </el-button>
                    <el-button
                        v-if="filetype != '2' && index < contractArray.length - 1"
                        type="null"
                        class="btn btn-null"
                        :disabled="!isScrolledToBottom"
                        :class="{ 'btn-disabled': !isScrolledToBottom }"
                        v-on:click="chooseItem(index + 1)"
                    >
                        下一份
                    </el-button>
                    <el-button
                        v-if="index == contractArray.length - 1"
                        type="primary"
                        class="btn"
                        :disabled="!isScrolledToBottom"
                        :class="{ 'btn-disabled': !isScrolledToBottom }"
                        v-on:click="handleConfirm"
                    >
                        确认内容并签署
                    </el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import ScriptImport from "@/components/util/scriptImport";
import weidu from "@/assets/img/icon-xieyi-weidu.png";
import yidu from "@/assets/img/icon-xieyi-yidu.png";
import userApi from "@/api/user";
import fundApi from "@/api/fund";
import commonApi from "@/api/common";
export default {
    name: "SignContractDialog",
    components: { ScriptImport },
    props: {
        // 是否显示弹窗（.sync修饰符实现双向绑定）
        visible: {
            type: Boolean,
            default: false
        },
        fundInfo: {
            type: Object,
            required: true
        },
        fund: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
            info: {},
            contractArray: [],
            index: 0,
            fileContent: null,
            pdfRenderPromise: null,
            pdfContainerShow: true,
            filetype: null,
            showRiskConfirm: false, // 展示风险揭示书逐条勾选
            riskConfirmOption: [],
            riskConfirmTitle: "",
            isScrolledToBottom: false,
            scrollDebounceTimer: null
        };
    },
    computed: {
        checkAllFlag() {
            const data = this.riskConfirmOption.filter((item) => {
                return !item.checkFlag;
            });

            if (data.length > 0) {
                return true;
            } else {
                return false;
            }
        }
    },
    mounted() {
        this.info = this.$cache.getUser();
        this.queryAwaitSignElecontract();
        this.qryFundReadFile();
    },
    beforeDestroy() {
        // 清除防抖计时器
        clearTimeout(this.scrollDebounceTimer);
    },
    methods: {
        chooseItem(index) {
            this.index = index;
            for (let i = 0; i < this.contractArray.length; i++) {
                if (index == i) {
                    this.contractArray[i].imgShow = yidu;
                    this.contractArray[i].currentFlag = true;
                } else {
                    this.contractArray[i].imgShow = weidu;
                    this.contractArray[i].currentFlag = false;
                }
            }

            this.isScrolledToBottom = false;
            const item = this.contractArray[index];
            this.filetype = item.filetype;
            this.removePdfCanvas();
            this.pdfRenderPromise = null;
            this.pdfContainerShow = true;
            this.initPdfCanvas(item);
        },
        initPdfCanvas: function (item) {
            let _this = this;
            this.getPdfBase64(item).then((res) => {
                _this.showPdf(item).then(function (res) {});
            });
        },
        async getPdfBase64(item) {
            let params = {
                fileCode: item.address
            };
            const res = await fundApi.getPdfBase64(params);
            if (res.data) {
                item.pdfBase64 = res.data;
            }
        },
        showPdf: function (item) {
            let _this = this;
            this.pdfRenderPromise = new Promise(function (resolve, reject) {
                window.PDFJS.getDocument(_this.getPath(item)).then(function (pdf) {
                    _this.renderPageAsync(pdf, 1, resolve);
                });
            });
            return this.pdfRenderPromise;
        },
        getPath: function (item) {
            return this.convertDataToBinary(item.pdfBase64);
        },
        convertDataToBinary(base64Data) {
            let raw = window.atob(base64Data);
            let rawLength = raw.length;
            let array = new Uint8Array(new ArrayBuffer(rawLength));
            for (let i = 0; i < rawLength; i++) {
                array[i] = raw.charCodeAt(i);
            }
            return array;
        },
        removePdfCanvas: function () {
            let el = document.getElementById("pdf-container");
            let childs = el.childNodes;
            for (let i = childs.length - 1; i >= 0; i--) {
                el.removeChild(childs[i]);
            }
            this.pdfContainerShow = false;
        },
        renderPageAsync: function (pdf, pageNum, resolve) {
            let container = document.getElementById("pdf-container");
            if (container) {
                let _this = this;
                if (pageNum <= pdf.numPages) {
                    pdf.getPage(pageNum).then(function (pages) {
                        let scale = 1.1;
                        let viewport = pages.getViewport(scale);
                        let canvas = document.createElement("canvas");
                        let context = canvas.getContext("2d");
                        container.appendChild(canvas);
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;
                        let renderContext = {
                            canvasContext: context,
                            viewport: viewport
                        };
                        pages.render(renderContext).then(function () {
                            _this.renderPageAsync(pdf, pageNum + 1, resolve);
                        });
                    });
                } else {
                    resolve();
                }
            }
        },
        async gotoRiskConfirm(index) {
            const data = this.riskConfirmOption.filter((item) => {
                return !item.checkFlag;
            });

            if (data.length > 0) {
                this.$message.info("存在未勾选的确认信息，请检查!");
                return false;
            }

            await commonApi.commonLeaveTracesLog(this, {
                eventid: this.$const.RECORD.fund_risk_agreement_agree,
                eventname: `风险揭示书提示内容确认`,
                content: JSON.stringify({
                    name: "风险揭示书提示内容确认",
                    content: "风险揭示书提示内容确认"
                })
            });

            this.showRiskConfirm = false;
            this.chooseItem(index);
        },
        async handleConfirm() {
            const contractList = this.contractArray.map((item) => {
                return {
                    textno: item.textno,
                    filetype: item.filetype,
                    version: item.version
                };
            });
            const signfiletype = this.contractArray.map((item) => {
                return item.filetype;
            });
            let param = {
                custno: this.info.custno,
                transactionaccountid: this.fundInfo.transactionaccountid,
                fundcode: this.fund.fundcode,
                contractList: contractList,
                signfiletype: signfiletype.join(","),
                matchflag: this.fund.riskmismatchflag,
                reviseversion: signfiletype.includes("1")
                    ? this.contractArray.filter((item) => {
                          return item.filetype == "1";
                      })[0].version
                    : "" // 已签署补充协议版本号(signfiletype包含1时 reviseversion必填)
            };

            const res = await userApi.combAppEleontractSign(param);
            if (res.code == 0) {
                this.$emit("confirm", res.data.contractno); // 发射确认事件，父组件处理后续逻辑
                this.$emit("update:visible", false); // 关闭弹窗（.sync修饰符）
            }
        },
        handleClose() {
            this.$emit("update:visible", false);
        },
        async queryAwaitSignElecontract() {
            let { data } = await userApi.queryAwaitSignElecontract({
                fundcode: this.fund.fundcode,
                custno: this.info.custno
            });

            this.contractArray = data.map((item, index) => {
                return {
                    textno: item.fileno,
                    title: item.title,
                    imgShow: index == 0 ? yidu : weidu,
                    currentFlag: index == 0,
                    filetype: item.filetype,
                    address: item.address,
                    pdfBase64: "",
                    version: item.version
                };
            });

            if (this.contractArray.length > 0) {
                this.chooseItem(0);
            }
        },
        async qryFundReadFile() {
            const { data } = await fundApi.qryFundReadFile({
                fundcode: this.fund.fundcode,
                sharetype: "",
                filetype: ""
            });
            const tempArray = data.filter((item) => {
                return item.filetype == "2";
            });

            if (tempArray.length > 0) {
                let investordeclaration = tempArray[0].investordeclaration;
                if (investordeclaration.startsWith("#")) {
                    investordeclaration = investordeclaration
                        .split("#")
                        .map((item) => item.replace(/^#\s*\d+、/, ""));
                    investordeclaration.shift(0);
                } else {
                    const ind = investordeclaration.indexOf("#");
                    this.riskConfirmTitle = investordeclaration.substring(0, ind);
                    investordeclaration = investordeclaration
                        .substring(ind)
                        .split("#")
                        .map((item) => item.replace(/^#\s*\d+、/, ""));
                    investordeclaration.shift(0);
                }

                this.riskConfirmOption = investordeclaration.map((item) => {
                    return {
                        checkFlag: false,
                        text: item
                    };
                });
            } else {
                this.$message.info("未查询到风险揭示书的确认信息");
            }
        },
        handleScroll() {
            // 防抖：避免频繁计算
            clearTimeout(this.scrollDebounceTimer);
            this.scrollDebounceTimer = setTimeout(() => {
                const container = this.$refs.pdfContainer;
                const content = this.$refs.pdfContent;

                if (!container || !content || content.children.length == 0) return;

                const containerHeight = container.clientHeight;
                const contentHeight = content.scrollHeight;
                const scrollPosition = container.scrollTop + containerHeight;

                const threshold = 160;
                this.isScrolledToBottom = scrollPosition >= contentHeight - threshold;
            }, 50); // 50ms 防抖延迟
        }
    }
};
</script>

<style scoped>
.dialog-content {
    line-height: 1.8;
    color: #333;
    display: flex;
    height: 562px;

    .left-title {
        width: 160px;
        border-right: 1px solid #eaeaea;
        font-size: 12px;
        color: #3b4050;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        height: 500px;

        .contract-item {
            display: flex;
            align-items: center;
            height: 50px;
            border-bottom: 1px solid #eaeaea;
            padding: 0 9px;
            border-radius: 2px;
        }

        .active {
            font-weight: bold;
            font-size: 12px;
            color: #fb3617;
            background: #ffebe8;
        }

        .img-size {
            width: 17px;
            height: 16px;
        }
    }

    .right-content {
        width: 670px;
        margin-left: 8px;

        .content-body {
            height: 470px;
            overflow-y: auto;
            overflow-x: hidden;
            border: 1px solid #eaeaea;
        }

        .content-body::-webkit-scrollbar {
            width: 10px;
            /* 垂直滚动条宽度 */
        }

        /* 滚动条轨道 */

        .content-body::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 6px;
        }

        .content-bottom {
            height: 28px;
            background: #f6f7fb;
            text-align: center;
            font-weight: 400;
            font-size: 12px;
            color: #595959;
            line-height: 28px;
        }
    }
}

.dialog-footer {
    margin: 18px 0;
    text-align: center;
}

/* 限制购买按钮样式（区分风险提示按钮） */
.forbid-btn {
    background-color: #909399;
    border-color: #909399;
    color: #fff;
}

.forbid-btn:hover {
    background-color: #797b7e;
    border-color: #797b7e;
}

.btn {
    height: 26px;
    font-size: 14px;
    line-height: 0;
}

.btn-null {
    border: 1px solid #fb3617;
    color: #fb3617;
}

.btn-disabled {
    opacity: 0.5;
}

.risk-confirm {
    height: 459px;
    overflow-y: auto;
    overflow-x: hidden;
    border: 1px solid #eaeaea;
    padding: 20px;

    .agree-box {
        display: flex;
        gap: 5px;
        margin-bottom: 15px;

        .agree-text {
            margin-top: -3px;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0;
            line-height: 17px;
            color: #333333;
        }
    }
}

/deep/ .el-checkbox .el-checkbox__inner {
    width: 20px;
    height: 20px;
    border: 1px solid #b9b9b9;
}

/deep/ .el-dialog__body {
    padding: 28px 20px 0 20px;
    overflow: hidden;
}
</style>
